import { Injectable } from '@angular/core';

/**
 * qty is a float column, so the screens round on the way in and never test it against zero
 * exactly. Every comparison in the stock UI goes through here so one epsilon governs the lot.
 */
@Injectable({
  providedIn: 'root'
})
export class StockQuantityService {

  /** Matches the rounding the backend applies before it writes a level. */
  private _decimalPlaces: number = 4;

  /** Comfortably below the smallest quantity a rounded qty can hold. */
  private _epsilon: number = 0.000001;

  /**
   * @param value the raw value off an input
   *
   * @returns number rounded to the precision the backend stores, 0 when unusable
   */
  round(value: any): number {
    const qty = Number(value);

    if (!Number.isFinite(qty)) {
      return 0;
    }

    const factor = Math.pow(10, this._decimalPlaces);

    return Math.round(qty * factor) / factor;
  }

  isZero(value: number): boolean {
    return Math.abs(this.round(value)) < this._epsilon;
  }

  isPositive(value: number): boolean {
    return this.round(value) > this._epsilon;
  }

  isNegative(value: number): boolean {
    return this.round(value) < -this._epsilon;
  }
}
